module.exports = __webpack_public_path__ + "img/2e50e30.png";